// extracted by mini-css-extract-plugin
module.exports = {"editor":"text-editor_editor__2GjBN"};